import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface SectorObject {
  id: number;
  slug: string;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
}

export interface SectorsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  sectors: Array<SectorObject>;
  errors: unknown;
}

@Module
export default class SectorsModule
  extends VuexModule
  implements SectorsListInfo
{
  sectors = [] as Array<SectorObject>;
  listDdlSectors = [] as Array<SectorObject>;

  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get sectors list
   * @returns Array<SectorObject>
   */
  get sectorsList(): Array<SectorObject> {
    return this.sectors;
  }

  /**
   * Get all none ive sectors list
   * @returns Array<SectorObject>
   */
  get allListSectors(): Array<SectorObject> {
    return this.listDdlSectors;
  }

  /**
   * Get total items
   * @returns number
   */
  get sectorsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_SECTORS](data) {
    this.sectors = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_SECTOR_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_SECTORS_LIST]() {
    this.sectors = [] as Array<SectorObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_SECTORS_STORE]() {
    this.context.commit(Mutations.RESET_SECTORS_LIST);
  }

  @Action
  [Actions.CREATE_SECTOR](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/sectors', data)
      .then(() => {
        this.context.commit(Mutations.RESET_SECTORS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_SECTOR](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/sectors', id)
      .then(() => {
        this.context.commit(Mutations.RESET_SECTORS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_SECTOR]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/sectors', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_SECTORS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_SECTOR_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_SECTOR_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_SECTOR](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/sectors', id);
  }

  @Action
  [Actions.GET_SECTORS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/sectors', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_SECTORS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }
}
